import { createReducer, on } from '@ngrx/store';

import { BetslipTypesActions } from '../actions';
import { defaultBaseTypeState } from './state';

export const baseTypeReducer = createReducer(
    defaultBaseTypeState,
    on(BetslipTypesActions.setActiveTypes, (state, action) => {
        return {
            ...state,
            activeTypes: action.betslipTypes,
        };
    }),
    on(BetslipTypesActions.setLinearTypes, (state, action) => {
        return {
            ...state,
            linearTypes: { ...action.types },
        };
    }),
    on(BetslipTypesActions.setSelectedType, (state, action) => {
        return {
            ...state,
            currentSelectedType: action.betslipType,
            selectedByUser: action.selectedByUser,
        };
    }),
    on(BetslipTypesActions.setSelectedByUser, (state, action) => {
        return {
            ...state,
            selectedByUser: action.isSelectedByUser,
        };
    }),
    on(BetslipTypesActions.setOriginalBase, (state, action) => {
        return {
            ...state,
            original: {
                activeTypes: state.activeTypes,
                currentSelectedType: state.currentSelectedType,
                selectedByUser: state.selectedByUser,
            },
        };
    }),
    on(BetslipTypesActions.setFromOriginalBase, (state, action) => {
        return {
            ...state,
            activeTypes: state.original.activeTypes,
            currentSelectedType: state.original.currentSelectedType,
            selectedByUser: state.original.selectedByUser,
            original: {
                activeTypes: [],
                currentSelectedType: null,
                selectedByUser: false,
            },
        };
    }),

    on(BetslipTypesActions.setDefaultOriginalBase, (state, action) => {
        return {
            ...state,
            original: {
                activeTypes: [],
                currentSelectedType: null,
                selectedByUser: false,
            },
        };
    }),
);
